import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Welcome.scss'

function Welcome() {
  const navigate = useNavigate();

  const ua = navigator.userAgent.toLowerCase();

  // useEffect(()=>{
  //   const uris = window.location.pathname.split('/users/ref/');
  //   console.log('uris',uris)
  //   if(uris.length > 0){
  //     console.log('uris',uris)
  //   }
  // },[])

  let redirectTimer;
  if(ua.match(/MicroMessenger/i) != 'micromessenger'){
    // 在3秒后自动跳转至登录页面
    redirectTimer = setTimeout(() => {
      navigate('/login');
      return () => {
        clearTimeout(redirectTimer);
      }; // 跳转至登录页面
    }, 5000);
  }
  
  const handleClick = () => {
    clearTimeout(redirectTimer);
    navigate('/login');
    // window.location.replace("http://localhost:3000/login");
    // window.location.href = ("/login");
    // window.history.pushState(null,'','/login')
  };

  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <h3>Please use default web broswer to open.</h3>
      </div>
    );
  }else{
    return (
      <button className="welcome-page d-flex flex-column justify-content-center align-items-center" onClick={handleClick}>
        <div className="welcome-content column-col-9 d-flex flex-column align-items-center">
          <img src={require("../../assets/images/logo.png")} alt="Logo"  className='welcome-logo'/>
          <h1 className='mt-5'>AskWei</h1>
          <h2 style={{position:"absolute", bottom:"100px"}}>Software copyright number: 1206342</h2>
        </div>
        <h3 className="column-col-3" style={{position:"absolute", bottom:"50px"}}>AI STUDY ASSISTANT</h3>
      </button>
    );
  }
}

export default Welcome